import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function useParam<T>(): T {
  const { search } = useLocation();
  return useMemo(() => {
    const obj = {} as T;
    if (!search) return obj;
    const [_, params = ''] = search.split('?');
    params.split('&').forEach(item => {
      const [key, value] = item.split('=');
      obj[key] = decodeURIComponent(value);
    });
    return obj;
  }, [search]);
}
/**
 * 获取URL中的指定查询参数
 * @param {string} param - 要获取的查询参数名称
 * @param {string} [url=window.location.href] - 可选，指定要解析的URL，默认为当前页面的URL
 * @returns {string|null} - 返回查询参数的值，如果不存在则返回null
 */
export function getQueryParam(param, url = window.location.href) {
  // 创建一个URL对象
  const urlObj = new URL(url);
  // 使用URLSearchParams来获取指定的查询参数
  const params = new URLSearchParams(urlObj.search);
  // 返回查询参数的值，如果不存在则返回null
  return params.get(param);
}
export default useParam;
